import React, {PropsWithChildren} from 'react';
import {useTranslation} from 'react-i18next';
import {IValidationErrorObject} from '../../../../../incase-domain/common/validationErrorResponse';
import {getErrorClasses} from '../../../../../utils/validation';
import SectionTitle from '../../../../elements/common/SectionTitle';
import Button from '../../../../../incase-domain/components/button/Button';

interface AnswersProps {
    errors: IValidationErrorObject | null;
    addAnswer?: () => void;
    noOfAnswers?: number;
    header?: JSX.Element;
}

function Answers(props: PropsWithChildren<AnswersProps>): JSX.Element {
    const {children, errors: validationErrors, addAnswer, noOfAnswers, header} = props;
    const {t} = useTranslation();

    return (
        <div className={`l-group--form c-newAnswer ${getErrorClasses(validationErrors, 'answers')}`}>
            <div className="u-flex u-v-center c-sidepanel__section_header ">
                <SectionTitle
                    label={`${t('designSidepanel.answers')}${noOfAnswers ? ` (${noOfAnswers})` : ''}`}
                    leading={
                        addAnswer && (
                            <Button
                                className="c-sequenceQuestionElementOrder__shuffleButton"
                                size="2xs"
                                variant="ghost"
                                color="primary"
                                onClick={addAnswer}
                                leading="ph:plus-bold"
                            >
                                {t('designSidepanel.new')}
                            </Button>
                        )
                    }
                />

                {header}
            </div>

            {children}
        </div>
    );
}

export default Answers;
